import { HttpClient, HttpContext, HttpHeaders, HttpParams } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { haveValue } from '@app/modules/shares/utils/functions/form'
import { Observable } from 'rxjs'

interface DeleteOptions {
  headers?: HttpHeaders | {
    [header: string]: string | string[]
  }
  context?: HttpContext
  observe?: 'body'
  params?: HttpParams | {
    [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>
  }
  reportProgress?: boolean
  responseType?: 'json'
  withCredentials?: boolean
  body?: any | null
}

@Injectable({ providedIn: 'root' })
export class VssApiService {
  hideNotifyError: boolean = false;
  baseUrl: string
  contextPath = '/api/v1/admin'

  constructor(
    private http: HttpClient,
  ) {
  }

  __getHeaders(httpHeaders?: HttpHeaders) {
    const newHeader = httpHeaders || (new HttpHeaders())
    if (!newHeader.has('HideNotifyError') && this.hideNotifyError) {
      newHeader.set('HideNotifyError', 'true')
    }
    return newHeader
  }

  getApiHost(url: string) {
    return `${this.baseUrl}${url}`
  }

  getBase(url: string, params?: any, httpHeaders?: HttpHeaders): Observable<any> {
    return this.http.get(url, {
      headers: this.__getHeaders(httpHeaders),
      observe: 'body',
      params: this.buildHttpParams(params)
    })
  }

  get(url: string, params?: any, httpHeaders?: HttpHeaders, reqOptions?: any): Observable<any> {
    return this.http.get(this.getApiHost(url), {
      headers: this.__getHeaders(httpHeaders),
      responseType: reqOptions?.responseType || 'json',
      observe: 'body',
      params: this.buildHttpParams(params)
    })
  }


  getParamsBase(url: string, params?: any, httpHeaders?: HttpHeaders, reqOptions?: any): Observable<any> {
    return this.http.get(this.getApiHost(url), {
      headers: this.__getHeaders(httpHeaders),
      responseType: reqOptions?.responseType || 'json',
      observe: 'body',
      params: params
    })
  }



  post(url: string, body: any, params?: any, reqOptions?: any, httpHeaders?: HttpHeaders): Observable<any> {
    return this.http.post(this.getApiHost(url), body,
      {
        headers: this.__getHeaders(httpHeaders),
        responseType: reqOptions?.responseType || 'json',
        observe: reqOptions?.observe || 'body',
        params: this.buildHttpParams(params)
      }
    )
  }

  postBase(url: string, body: any, params?: any, reqOptions?: any, httpHeaders?: HttpHeaders): Observable<any> {
    return this.http.post(url, body,
      {
        headers: this.__getHeaders(httpHeaders),
        responseType: reqOptions?.responseType || 'json',
        params: this.buildHttpParams(params)
      }
    )
  }


  put(url: string, body: any, params?: any, reqOptions?: any, httpHeaders?: HttpHeaders): Observable<any> {
    return this.http.put(this.getApiHost(url), body,
      {
        headers: this.__getHeaders(httpHeaders),
        responseType: reqOptions?.responseType || 'json',
        params: this.buildHttpParams(params)
      }
    )
  }

  patch(url: string, body: any, params?: any, reqOptions?: any, httpHeaders?: HttpHeaders): Observable<any> {
    return this.http.patch(this.getApiHost(url), body,
      {
        headers: this.__getHeaders(httpHeaders),
        responseType: reqOptions?.responseType || 'json',
        params: this.buildHttpParams(params)
      })
  }

  delete(url: string, options?: DeleteOptions): Observable<any> {
    return this.http.delete(this.getApiHost(url), options)
  }

  postFormData(url: string, body: any, params?: any) {
    const data = new FormData()
    Object.keys(body).forEach(x => {
      data.append(x, body[x])
    })
    return this.http.post(this.getApiHost(url), data, { params: this.buildHttpParams(params) }
    )
  }

  buildHttpParams(paramObj: any): HttpParams {
    let params = new HttpParams()
    let obj = paramObj
    if (obj) {
      obj = this.removeNullFields(obj)
    }

    const keys = paramObj ? Object.keys(obj) : null

    if (keys && keys.length > 0) {
      keys.forEach((key, i) => {
        if (key) {
          // if(isArray(paramObj[key])){
          //   paramObj[key].forEach((x:any)=>{
          //     params = params.append(key, `${x}`);
          //   })

          // }else{
          params = params.set(key, `${paramObj[key]}`)
          // }

        }
      })
    }
    return params
  }

  removeNullFields(obj: any): any {
    return Object.entries(obj)
      .filter(([_, value]) => haveValue(value))
      .reduce((acc, [key, value]) => {
        acc[key] = value
        return acc
      }, {} as any)
  }

  getFile(url: string, httpHeaders?: HttpHeaders): Observable<any> {
    return this.http.get(this.getApiHost(url), {
      headers: this.__getHeaders(httpHeaders),
      observe: "response" as 'body',
      responseType: 'blob' as 'json'
    })
  }

  postFormDataWithFiles(url: string, body: any, files?: any) {
    const data = new FormData()
    Object.keys(body).forEach(x => {
      data.append(x, body[x])
    })

    if (files) {
      files.forEach((f: any) => {
        data.append('files', f)
      })
    }
    return this.http.post(this.getApiHost(url), data, { params: this.buildHttpParams(null) }
    )
  }
}
